module.exports = __webpack_public_path__ + "static/fx_11.059605b9.jpg";